/* eslint-disable no-nested-ternary */
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePolicyInfoContext } from "../contexts/policyInfoContext";
import { formatMoney } from "utils/helpers";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: "1rem",
    color: "black",
    fontWeight: "bold"
  },
  text: {
    fontSize: "1rem",
    color: "black"
  },
  link: {
    color: "#6969fb",
    fontWeight: "bold",
    textDecoration: "none"
  },
  boldText: {
    fontWeight: "bold",
  }
}));

export const InsuranceCoverageText = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { id: orderId } = useParams<{ id: string }>();
  const { insuranceInfo, selectedTab } = usePolicyInfoContext();

  const amount = (selectedTab?.id === "owners_policy_tab" ? insuranceInfo?.purchaseAmount : insuranceInfo?.loanAmount) ?? 0;
  const parties = (selectedTab?.id === "owners_policy_tab" ? insuranceInfo?.buyers : insuranceInfo?.lenders) ?? [];
  return (
    <Box>
      <Typography className={classes.title}>
        {t('policyInfoAndRates:totalCoverage')}
      </Typography>
      <Typography className={classes.text}>
        {`Insurance coverage of `}
        <span className={classes.boldText}>{formatMoney(amount)}</span>
        {parties.length ? " for " : ""}
        {parties.map((party, partyIndex) => (
          <React.Fragment key={party.id}>
            {parties.length > 1 && parties.length - 1 === partyIndex ? "and " : ""}
            <Link to={`/orders/details/${orderId}/parties/${party.id}`} className={classes.link}>
              {party.name}
            </Link>
            {parties.length - 1 === partyIndex ? "." : (parties.length - 2 !== partyIndex ? ", " : " ")}
          </React.Fragment>
        ))}
      </Typography>
    </Box>
  );
};
